// src/lib/fetchWithAuth.js
import { getAuth } from "firebase/auth";

/**
 * Makes a fetch request with Firebase ID token automatically added.
 * @param {string} url - The endpoint to call
 * @param {object} options - Fetch options (method, headers, body, etc.)
 * @returns {Promise<Response>} - The fetch response
 */
const fetchWithAuth = async (url, options = {}) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error("User is not logged in.");
  }

  const token = await user.getIdToken();

  const authHeaders = {
    Authorization: `Bearer ${token}`,
    ...options.headers,
  };

  try {
    const response = await fetch(url, {
      ...options,
      headers: authHeaders,
    });

    // Optional: handle common auth errors
    if (response.status === 401) {
      console.warn("Unauthorized request. Token might be invalid.");
    }

    return response;
  } catch (err) {
    console.warn(err.message);
    throw new Error(err);
  }
};

export default fetchWithAuth;
